export default {
    namespaced: true,
    state: () => ({
        orchard_pop_stream_url: null,
        orchard_pop_stream_url_alt: null,
        orchard_pop_stream_url_cn: null,
        orchard_pop_stream_url_alt_cn: null,
        orchard_pop_survey_url: null,
        groove_together_stream_url: null,
        groove_together_stream_url_alt: null,
        groove_together_stream_url_cn: null,
        groove_together_stream_url_alt_cn: null,
        groove_together_survey_url: null,
        hardrock_stream_url: null,
        hardrock_stream_url_alt: null,
        hardrock_stream_url_cn: null,
        hardrock_stream_url_alt_cn: null,
        hardrock_survey_url: null,
        the_wealth_symphony_stream_url: null,
        the_wealth_symphony_stream_url_alt: null,
        the_wealth_symphony_stream_url_cn: null,
        the_wealth_symphony_stream_url_alt_cn: null,
        the_wealth_symphony_survey_url: null,
        peacetopia_stream_url: null,
        peacetopia_stream_url_alt: null,
        peacetopia_stream_url_cn: null,
        peacetopia_stream_url_alt_cn: null,
        peacetopia_survey_url: null,
        test_room_stream_url: null,
        test_room_stream_url_alt: null,
        test_room_stream_url_cn: null,
        test_room_stream_url_alt_cn: null,
        test_room_survey_url: null,
        stamp_end_date: null, 
        notification_text: null, 
        is_event_start: false, 
        is_public_access: false,
        is_release_dlc: false,
        is_public_feedback: false,
        is_stream_start: false,
        is_show_live_chat: false, 
        is_show_live_emoji: false, 
        is_show_live_polling: false, 
        is_show_notification: false, 
        is_show_post_question: false,
        week: 1,
        week_stg: 1,
        peacetopia_quotes: [],
        set360: null,
        set360_stg: null,
        is_setting_ready: false,
    }),
    actions: {
        SOCKET_onGetSetting({ commit }, res){
           console.log('SOCKET_onGetSetting ->', res);
           commit('setItem', res.item);
        },
        SOCKET_onGlobalUpdateSetting({ commit }, res){
            console.log('SOCKET_onGlobalUpdateSetting ->', res);
            commit('updateItem', { key: res.item.name, value: res.item.value });
        },
        SOCKET_onGlobalRefreshPage({ commit }, res){
            console.log('SOCKET_onGlobalRefreshPage ->', res);
            window.location.reload(true);
        },
        SOCKET_onGlobalEnterAuditorium({ commit, rootState }, res){
            console.log('SOCKET_onGlobalEnterAuditorium ->', res);
            if(rootState.auth.user){
                this.$router.push({ path: '/auditorium/' });
            }
        },
        SOCKET_onGlobalShowAuditoriumNoti({ state, commit, rootState }, res){
            console.log('SOCKET_onGlobalShowAuditoriumNoti ->', res);
            if(rootState.auth.user && !window.location.pathname.includes('auditorium')){
                this.$swal({
                    icon: 'info',
                    html: `<p>${ state.notification_text }</p>`
                }).then((result) => {
                    if(result.isConfirmed){
                        this.$router.push({ path: '/auditorium/' });
                    }
                })
            }
        },
        SOCKET_onGlobalNotification({ state, commit, rootState }, res){
            console.log('SOCKET_onGlobalNotification ->', res);
            if(rootState.auth.user){
                this.$swal({
                    icon: 'info',
                    html: `<p>${state.notification_text}</p>`
                });
            }
        },
    },
    mutations: {
        setItem(state, item){
            Object.keys(state).forEach((key) => {
                if(item[key]){
                    state[key] = item[key];
                }
            });
            state.is_setting_ready = true;
        },
        updateItem(state, { key, value }){
            state[key] = value;
        },
    }
}

